import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page-font-icons',
    templateUrl: './page-font-icons.component.html',
    styleUrls: ['./page-font-icons.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageFontIconsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner = {
    image: "assets/images/banner/6.jpg",
    title: "Icon Font Style",
    description: "The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.",
    page: "Icon Fonts"
  }

  footerData = {
    backExists: "0",
    wallpaper: ""
  }

  fontIcons = [
    "flaticon-sketch",
    "flaticon-stairs",
    "flaticon-window",
    "flaticon-skyline",
    "flaticon-bed",
    "flaticon-door",
    "flaticon-living-room",
    "flaticon-door-1",
    "flaticon-window-1",
    "flaticon-closet",
    "flaticon-stairs-1",
    "flaticon-vase",
    "flaticon-desk",
    "flaticon-lamp",
    "flaticon-armchair",
    "flaticon-window-2",
    "flaticon-bed-1",
    "flaticon-chair",
    "flaticon-lamp-1",
    "flaticon-table",
    "flaticon-mirror",
    "flaticon-bookcase",
    "flaticon-cactus",
    "flaticon-blueprint",
    "flaticon-tv",
    "flaticon-chest",
    "flaticon-desk-1",
    "flaticon-chandelier",
    "flaticon-clock",
    "flaticon-coat-stand",
    "flaticon-chest-1",
    "flaticon-3d",
    "flaticon-architect",
    "flaticon-barrier",
    "flaticon-bed-2",
    "flaticon-blueprint-1",
    "flaticon-building",
    "flaticon-building-1",
    "flaticon-certificate",
    "flaticon-contract",
    "flaticon-cornice",
    "flaticon-dimensions",
    "flaticon-door-2",
    "flaticon-drawing-table",
    "flaticon-electric-pole",
    "flaticon-fence",
    "flaticon-helmet",
    "flaticon-home",
    "flaticon-home-1",
    "flaticon-lift",
    "flaticon-living-room-1",
    "flaticon-house",
    "flaticon-measuring-tape",
    "flaticon-parquet",
    "flaticon-blueprint-2",
    "flaticon-power-strip",
    "flaticon-project",
    "flaticon-paint-roller",
    "flaticon-ruler",
    "flaticon-table-1",
    "flaticon-sketch-1",
    "flaticon-ruler-1",
    "flaticon-set-square",
    "flaticon-table-2",
    "flaticon-table-3",
    "flaticon-bed-3",
    "flaticon-stairs-2",
    "flaticon-brick-wall",
    "flaticon-real-estate",
    "flaticon-window-3",
    "flaticon-window-4"
  ]
}
